import {createSlice} from '@reduxjs/toolkit';

export const initialState = {
  estimatedQuantity: null,
  isIntl: false
};

/**
 * I needed somewhere to store the estimated quantity.  This could go in the quote reducer,
 * but since the whole quote widget should be thrown into the Sun, I'm putting it here.
 *
 * Note that _when_ the simple_pricing A/B test fails, this slice can probably be removed as well, unless
 * someone is finally replacing the quote widget completely.
 */
const priceSlice = createSlice({
  name: 'price',
  initialState,
  reducers: {
    setEstimatedQty: (state, {payload}) => ({
      ...state,
      estimatedQuantity: payload
    }),
    // This brittle, hacky flag is set to true when the user clicks the international link
    // on the zipQty page.  It's used by the SizeQty page (<QuoteFormView>) to
    // skip directly to international Quote page.
    setIntl: (state, {payload}) => ({
      ...state,
      isIntl: payload
    })
  }
});

export const {setEstimatedQty, setIntl} = priceSlice.actions;
export default priceSlice.reducer;

// Selectors
export const getEstimatedQty = state => state.price.estimatedQuantity;
export const getIsIntl = state => state.price.isIntl;
